import React from "react";
import { Form } from "react-bootstrap";
import { useArsListing } from "./ArsListingContextProvider";
import { ARSL_SET_VARIABLE_FILTER } from "./interface";

/**
 * VariableFilter provides a text input that filters the variable sidebar items
 * by matching against each variable's name or description.
 *
 * @returns Variable filter input element, or null when there is no listing context
 */
export const VariableFilter = (): React.ReactNode => {
  const { state, dispatch } = useArsListing();

  return !state ? null : (
    <Form.Control
      size="sm"
      type="text"
      aria-label="Filter variables"
      placeholder="Filter variables…"
      value={state.settings.variableFilter}
      disabled={state.settings.disabled}
      onChange={(event) => {
        dispatch({
          operation: ARSL_SET_VARIABLE_FILTER,
          variableFilter: event.currentTarget.value,
        });
      }}
    />
  );
};

VariableFilter.displayName = "VariableFilter";
